import React from "react";
import DashboardNav from "../components/DashboardNav";
import { Container, Row, Col, Card } from "react-bootstrap";
import HubspotContactForm from "../components/HubspotContactForm";

const SourcingManagement = () => {
    return (
        <>
            <Container>
                <Row>
                    <Col xs={12} className="mt-2">
                        <h1>Sourcing Management</h1>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <HubspotContactForm portalId="5956590" formId="da97b4d1-ec67-403e-9b7e-1e649adecdc0"/>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default SourcingManagement